var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"click:append-outer":_vm.search,"input":_vm.onInput}},'v-text-field',_vm.defaultConfigs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }